import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import { sendPostRequest } from "./../../APP/HELPERS/requests"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions.js';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';

import InnerModalProduct from './../../APP/COMPONENTS/ContentParts/InnerModalProduct';

function mapStateToProps(state) {
    return {
        PRODUCT_MODAL: state.PRODUCT_MODAL
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}

class Product extends Component {

    /// CONSTRUCTOR ///
    constructor(props)
    {
        super(props);
        this.state = {
            PRODUCT: false
        };

        this.OFFSET = 0;
    }

    componentDidUpdate(prevProps, prevState, snapshot)
    {
        if (this.props.PRODUCT_MODAL !== prevProps.PRODUCT_MODAL) {
            if (window.innerWidth < 1200) {
                if (!this.props.PRODUCT_MODAL) {
                    document.body.classList.remove("modal-open");
                    document.documentElement.scrollTop = this.OFFSET;
                } else {
                    this.OFFSET = window.pageYOffset || document.documentElement.scrollTop;
                    document.body.classList.add("modal-open");
                }
            }
        }
    }
    
	render()
    {
        if (this.props.PRODUCT_MODAL) {
            return (
                <div>
                    <div className="modal-overlay" onClick={() => this.props.openProductModal(false)}>
                    </div>
                    <div className="modal-box product-card">
                        <a className="close-modal" onClick={() => this.props.openProductModal(false)}>
                            <img src="/system_images/close.png" />
                        </a>
                        <InnerModalProduct ID={this.props.PRODUCT_MODAL} />
                    </div>
                </div>
            );
        } else {
            return false;
        }
    }
}

export default connect(
    mapStateToProps, mapDispatchToProps
)(Product);